import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/home/Hero";
import { MarqueeBand } from "@/components/MarqueeBand";
import { ForBuilders } from "@/components/home/ForBuilders";
import { Services } from "@/components/home/Services";
import { Gallery } from "@/components/home/Gallery";
import { R3Services } from "@/components/home/R3Services";
import { About } from "@/components/home/About";
import { ServiceArea } from "@/components/home/ServiceArea";
import { Faq } from "@/components/home/Faq";
import { CompaniesSection } from "@/components/home/CompaniesSection";
import { FeaturedReviews } from "@/components/home/FeaturedReviews";
import { Contact } from "@/components/home/Contact";
import { useSmoothScroll } from "@/lib/smoothScroll";

export default function HomePage() {
  const { scrollTo } = useSmoothScroll();
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const hash = location.hash;
      const timer = setTimeout(() => scrollTo(hash), 200);
      return () => clearTimeout(timer);
    }
  }, [location.hash, scrollTo]);

  return (
    <main data-testid="home-page">
      <Hero />
      <MarqueeBand />
      <ForBuilders />
      <Services />
      <Gallery />
      <CompaniesSection />
      <R3Services />
      <About />
      <ServiceArea />
      <Faq />
      <FeaturedReviews />
      <Contact />
    </main>
  );
}
